import React, { useEffect, useState } from 'react';
import useMedia from 'use-media';
import { Label } from '../../atoms/RTCC/label';
import { PullDownOptionForm } from './pullDownOptionForm';

export const FlightTimeForm = (props) => {
    const { hourId, minuteId, hourValue, minuteValue, onChange, outOrIn } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });

    const [hour, setHour] = useState([]);
    const [minute, setMinute] = useState([]);

    useEffect(() => {
        setHour([
            { value: "00", id: "00" }, { value: "01", id: "01" }, { value: "02", id: "02" },
            { value: "03", id: "03" }, { value: "04", id: "04" }, { value: "05", id: "05" },
            { value: "06", id: "06" }, { value: "07", id: "07" }, { value: "08", id: "08" },
            { value: "09", id: "09" }, { value: "10", id: "10" }, { value: "11", id: "11" },
            { value: "12", id: "12" }, { value: "13", id: "13" }, { value: "14", id: "14" },
            { value: "15", id: "15" }, { value: "16", id: "16" }, { value: "17", id: "17" },
            { value: "18", id: "18" }, { value: "19", id: "19" }, { value: "20", id: "20" },
            { value: "21", id: "21" }, { value: "22", id: "22" }, { value: "23", id: "23" },
        ]);
        let minuteList = [];
        for (let i = 0; i < 60; i++) {
            let minuteObj = {
                value: i <= 9 ? "0" + i : i,
                id: i <= 9 ? "0" + i : i,
            }
            minuteList.push(minuteObj);
        }
        setMinute(minuteList);
    }, []);

    return (
        <div className="confirmLabelTextWrap">
            {props.confirmText == null ?
                <div style={props.pullDownAreaStyle} className="">
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        data={hour}
                        state={hourValue}
                        onChange={() => onChange(hourId, outOrIn)}
                        id={hourId}
                    />
                    <span className={props.hourLabel}>{props.hourTitle}</span>
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        data={minute}
                        state={minuteValue}
                        onChange={() => onChange(minuteId, outOrIn)}
                        id={minuteId}
                    />
                    <span className={props.minuteLabel}>{props.minitTitle}</span>
                </div>
                :
                <Label label={props.confirmText} className="confirmLabelText" />
            }
        </div>
    );
}
